import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";
import { getPaginationUrl } from "../../utils/constants/GetPaginationURL";

const initialState = {
  categoryData: [],
  brandData: [],
  categoryAllData: [],
  brandDataList: [],
  productData: [],
  vendorData: [],
  loading: false,
  resData: {
    data: [],
    meta: {},
  },
  quotationsData: [],
  purchasedDetails: {},
  saleDetails: {},
  categoryTypes: [],
  categoryTypesNoLimit: [],
  subCategoryData: [],
  productDataForRequirement: [],
  productSerialData: [],
  inventoryData: {},
  allSubCatData: [],
  userPurchaseList: [],
  dashboardData: {},
  departments: [],
  usersUnderDepartment: [],
  allProductsCount: [],
  chartData: [],
  allDepartments: [],
  usersunderdpt: [],
  fileName: {},
  fileUploadLoading:false
};
// ----------------------------------categorycrud-----------------------------------
export const getAllCategory = createAsyncThunk(
  "asset/allcategories",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `category/?page=${data.page}&limit=${data.limit}&category_status=${data.category_status}`,
    });
    return res;
  }
);
export const getAllCategoryNoLimit = createAsyncThunk(
  "asset/allcategoriesnolimit",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `category?category_status=0?page=no&limit=no`,
    });
    return res;
  }
);

export const addCategory = createAsyncThunk(
  "asset/addcategory",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: "category",
      data: data,
    });
    return res;
  }
);

export const updateCategory = createAsyncThunk(
  "asset/updatecategory",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: "category",
      data: data,
    });
    return res;
  }
);

export const deleteCategory = createAsyncThunk(
  "asset/deletecategory",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `category/${id}`,
    });
    return res;
  }
);
// -----------------------------------------brandcrud-------------------------------
export const getAllBrands = createAsyncThunk(
  "asset/allbrands",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `brands/?page=${data.page}&limit=${data.limit}&brand_status=${data.brand_status}`,
    });
    return res;
  }
);

export const getAllBrandsList = createAsyncThunk(
  "asset/allbrandslist",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `brands?brand_status=0&limit=no`,
    });
    return res;
  }
);

export const addBrand = createAsyncThunk("asset/addbrand", async (data) => {
  const res = await apiRequest({
    method: "post",
    url: "brands",
    data: data,
  });
  return res;
});

export const updateBrand = createAsyncThunk(
  "asset/updatebrand",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: "brands",
      data: data,
    });
    return res;
  }
);

export const deleteBrand = createAsyncThunk("asset/deletebrand", async (id) => {
  const res = await apiRequest({
    method: "delete",
    url: `brands/${id}`,
  });
  return res;
});
// -------------------------------------productCrud---------------------------------------------------
export const getAllProducts = createAsyncThunk(
  "asset/allproducts",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `products/?page=${data.page}&limit=${data.limit}&product_status=${data.status}&category_id=${data.category}&brand_id=${data.brand}&search=${encodeURIComponent(data?.search)}`,
    });
    return res;
  }
);

export const addProduct = createAsyncThunk("asset/addproduct", async (data) => {
  const res = await apiRequest({
    method: "post",
    url: "products",
    data: data,
  });
  return res;
});

export const updateProduct = createAsyncThunk(
  "asset/updateproduct",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: "products",
      data: data,
    });
    return res;
  }
);

export const deleteProduct = createAsyncThunk(
  "asset/deleteproduct",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `products/${id}`,
    });
    return res;
  }
);

// ------------------------------------vendor-----------------------------------------------
export const getAllVendors = createAsyncThunk(
  "asset/allvendors",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `vendor-management?page=${data.page}&limit=${data.limit}&filter=${data.filter}`,
    });
    return res;
  }
);

export const addVendor = createAsyncThunk("asset/addvendors", async (data) => {
  const res = await apiRequest({
    method: "post",
    url: `vendor-management`,
    data: data,
  });
  return res;
});

export const updateVendor = createAsyncThunk(
  "asset/updatevendors",
  async (data) => {
    const { vendorID, ...rest } = data;
    const res = await apiRequest({
      method: "put",
      url: `vendor-management/${vendorID}`,
      data: rest,
    });
    return res;
  }
);

export const deleteVendor = createAsyncThunk(
  "asset/deletevendors",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `vendor-management/${id}`,
    });
    return res;
  }
);

export const getAllProductsWithoutPagination = createAsyncThunk(
  "quotation/getAllProductsWithoutPagination",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `products/?limit=no&product_status=0`,
    });
    return res;
  }
);

export const getAllVendorsWithoutPagination = createAsyncThunk(
  "quotation/getAllVendorsWithoutPagination",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `vendor-management?limit=no`,
    });
    return res;
  }
);

export const getQuotationRequirements = createAsyncThunk(
  "quotation/getQuotationRequirements",
  async (dispatchParams) => {
    const { paginationData } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: "get",
      url: `quotation-management/quotation-requirements/${paginationUrl}`,
    });
    return res;
  }
);

export const createRequirement = createAsyncThunk(
  "quotation/createRequirement",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `quotation-management`,
      data: data,
    });
    return res;
  }
);

export const getQuotationsOfRequrements = createAsyncThunk(
  "quotation/getQuotationsOfRequrements",
  async (requirementID) => {
    const res = await apiRequest({
      method: "get",
      url: `quotation-management/quotations?requirementID=${requirementID}&limit=no`,
    });
    return res;
  }
);

export const updateQuotations = createAsyncThunk(
  "quotation/updateQuotations",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: `quotation-management/${data.id}`,
      data: data,
    });
    return res;
  }
);

export const deleteQuotation = createAsyncThunk(
  "quotation/deleteQuotation",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `quotation-management/${id}`,
    });
    return res;
  }
);

export const approveQuotation = createAsyncThunk(
  "quotation/approveQuotation",
  async (id) => {
    const res = await apiRequest({
      method: "post",
      url: `quotation-management/approve?quotationID=${id}`,
    });
    return res;
  }
);

export const getPurchasedItems = createAsyncThunk(
  "purchase/getPurchasedItems",
  async (dispatchParams) => {
    const {
      paginationData,
      typeId,
      categoryId,
      subCatId,
      damageStatus,
      vendorId,
    } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: "get",
      url: `purchase-management${paginationUrl}&subCategory=${subCatId}&category=${categoryId}&type=${typeId}&isDamaged=${
        damageStatus == -1 ? null : damageStatus
      }&vendorID=${vendorId}`,
    });
    return res;
  }
);

export const createPurchase = createAsyncThunk(
  "purchase/createPurchase",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `purchase-management`,
      data: data,
    });
    return res;
  }
);

export const updatePurchase = createAsyncThunk(
  "purchase/updatePurchase",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: `purchase-management/${data.id}`,
      data: data,
    });
    return res;
  }
);

export const createSale = createAsyncThunk("sale/createSale", async (data) => {
  const res = await apiRequest({
    method: "post",
    url: `sales-management`,
    data: data,
  });
  return res;
});

export const getSale = createAsyncThunk(
  "sale/getSale",
  async (dispatchParams) => {
    const {
      paginationData,
      isAssetManagement = false,
      typeId,
      categoryId,
      subCatId,
      damageStatus,
      vendorId,
      approvalStatus,
      deliveryStatus,
      departmentId,
      userId,
    } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const url = isAssetManagement
      ? `sales-management/get-approved-requests${paginationUrl}&subCategory=${subCatId}&category=${categoryId}&type=${typeId}&isDamaged=${damageStatus}&vendorID=${vendorId}&approvalStatus=${approvalStatus}&deliveryStatus=${deliveryStatus}&departmentId=${departmentId}&userId=${userId}`
      : `sales-management${paginationUrl}`;
    const res = await apiRequest({
      method: "get",
      url: url,
    });
    return res;
  }
);

export const updateSale = createAsyncThunk("sale/updateSale", async (data) => {
  const res = await apiRequest({
    method: "put",
    url: `sales-management/${data.id}`,
    data: data,
  });
  return res;
});

export const deleteSale = createAsyncThunk("sale/deleteSale", async (id) => {
  const res = await apiRequest({
    method: "delete",
    url: `sales-management/${id}`,
  });
  return res;
});

export const approveOrRejectSaleRequest = createAsyncThunk(
  "sale/approveOrRejectSaleRequest",
  async ({ saleId, status }) => {
    const res = await apiRequest({
      method: "post",
      url: `sales-management/${saleId}/${status}`,
    });
    return res;
  }
);

export const verifySaleTheProduct = createAsyncThunk(
  "sale/verifySaleTheProduct",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `sales-management/${data.id}`,
      data: data,
    });
    return res;
  }
);

export const handBackTheProduct = createAsyncThunk(
  "sale/handBackTheProduct",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `sales-management/return-sale/${data.id}`,
      data: data,
    });
    return res;
  }
);

export const getProductListForAddRequirement = createAsyncThunk(
  "quotation/getProductListForAddRequirement",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `/sub-category?page=no&limit=no`,
    });
    return res;
  }
);

export const availableProductsCodeAndTypes = createAsyncThunk(
  "quotation/availableProductsCodeAndTypes",
  async (subCategoryId) => {
    const res = await apiRequest({
      method: "get",
      url: `/inventory-management/get-available-products/${subCategoryId}`,
    });
    return res;
  }
);

export const getInventoryData = createAsyncThunk(
  "quotation/getInventoryData",
  async (dispatchParams) => {
    const { paginationData } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: "get",
      url: `inventory-management/product-list/${paginationUrl}`,
    });
    return res;
  }
);

export const getCategoryTypes = createAsyncThunk(
  "asset/getCategoryTypes",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `category-types/?page=${data.page}&limit=${data.limit}`,
    });
    return res;
  }
);
export const getCategoryTypesNoLimit = createAsyncThunk(
  "asset/getCategoryTypesNoLimit",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `category-types/?page=no&limit=no`,
    });
    return res;
  }
);
export const updateCategoryTypes = createAsyncThunk(
  "asset/updateCategoryTypes",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: `category-types`,
      data: data,
    });
    return res;
  }
);
export const addCategoryTypes = createAsyncThunk(
  "asset/addCategoryTypes",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `category-types`,
      data: data,
    });
    return res;
  }
);
export const deleteCategoryTypes = createAsyncThunk(
  "asset/deleteCategoryTypes",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `category-types/${id}`,
    });
    return res;
  }
);
export const getSubcategories = createAsyncThunk(
  "asset/getSubcategories",
  async (id) => {
    const res = await apiRequest({
      method: "get",
      url: `sub-category?category_id=${id}&limit=no`,
    });
    return res;
  }
);
export const addSubCategory = createAsyncThunk(
  "asset/addSubCategory",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `sub-category`,
      data: data,
    });
    return res;
  }
);
export const updateSubcategory = createAsyncThunk(
  "asset/updateSubcategory",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: `sub-category/${data.sub_category_id}`,
      data: data,
    });
    return res;
  }
);
export const deleteSubcategory = createAsyncThunk(
  "asset/deleteSubcategory",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `sub-category/${id}`,
    });
    return res;
  }
);
export const markAsDamaged = createAsyncThunk(
  "sale/markAsDamaged",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `inventory-management/add-to-damage/${data.purchaseId}`,
      data: data,
    });
    return res;
  }
);
export const revertToGoodCondition = createAsyncThunk(
  "sale/revertToGoodCondition",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `inventory-management/add-to-working/${data.purchaseId}`,
      data: data,
    });
    return res;
  }
);

export const getAllSubCatWithNoLimit = createAsyncThunk(
  "asset/getAllSubCatWithNoLimit",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `/sub-category?page=no&limit=no`,
    });
    return res;
  }
);
export const viewUsersList = createAsyncThunk(
  "asset/viewUsersList",
  async (prodId) => {
    const res = await apiRequest({
      method: "get",
      url: `inventory-management/get-product-users/${prodId}`,
    });
    return res;
  }
);

export const getDashboardData = createAsyncThunk(
  "quotation/getDashboardData",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `asset-dashboard/get-datas`,
    });
    return res;
  }
);

export const updateDeliveryTime = createAsyncThunk(
  "asset/updateDeliveryTime",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: `sales-management/add-expected-delivery-data/${data.salesID}`,
      data: data,
    });
    return res;
  }
);

export const approveOrRejectProcurementHead = createAsyncThunk(
  "sale/approveOrRejectProcurementHead",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `sales-management/procurement-head-approval/${data.saleId}/${data.status}`,
    });
    return res;
  }
);

export const getAllDepartments = createAsyncThunk(
  "sale/getAllDepartments",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `department-management/getDepartments?page=1&limit=no`,
    });
    return res;
  }
);

export const getUsersUnderDepartment = createAsyncThunk(
  "sale/getUsersUnderDepartment",
  async (departmentId) => {
    const res = await apiRequest({
      method: "get",
      url: `sales-management/get-department-user/${departmentId}`,
    });
    return res;
  }
);

export const getAllProductsCount = createAsyncThunk(
  "sale/getAllProductsCount",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `inventory-management/get-all-products-count?search=${data.search}`,
    });
    return res;
  }
);

export const getChartdata = createAsyncThunk("sale/getChartdata", async () => {
  const res = await apiRequest({
    method: "get",
    url: `inventory-management/get-department-wise-count`,
  });
  return res;
});

export const fetchAlldepartments = createAsyncThunk(
  "asset/fetchAlldepartments",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: "department-management/getDepartments?page=1&limit=no",
    });
    return res;
  }
);

export const fetchUserunderdepartment = createAsyncThunk(
  "asset/fetchUserunderdepartment",
  async (departmentID) => {
    const res = await apiRequest({
      method: "get",
      url: `department-management/getEmployees/${departmentID}`,
    });
    return res;
  }
);

export const changeUser = createAsyncThunk("sale/changeUser", async (data) => {
  const res = await apiRequest({
    method: "post",
    url: `sales-management/change-user/${data.saleId}`,
    data: data,
  });
  return res;
});


export const holdOrReject = createAsyncThunk(
  "quotation/holdOrReject",
  async (data) => {
      const {quotationId} =data
    const res = await apiRequest({
      method: "post",
      url: `quotation-management/holdOrReject?quotationID=${quotationId}`,
       data: data,
    });
    return res;
  }
);


export const commonFileUpload = createAsyncThunk('quotation/commonFileUpload', async (formData) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/file-upload`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res;
});


const assetSlice = createSlice({
  name: "asset",
  initialState,

  reducers: {
    clearQuotationsDataArray(state) {
      state.quotationsData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryData = action.payload;
    });
    builder.addCase(getAllCategoryNoLimit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCategoryNoLimit.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryAllData = action.payload;
    });
    builder.addCase(addCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCategory.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // ------------------------------------update--------------------------------
    builder.addCase(updateCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(deleteCategory.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteCategory.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------------------brand------------------------------------------
    builder.addCase(getAllBrands.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllBrands.fulfilled, (state, action) => {
      state.loading = false;
      state.brandData = action.payload;
    });
    builder.addCase(getAllBrandsList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllBrandsList.fulfilled, (state, action) => {
      state.loading = false;
      state.brandDataList = action.payload;
    });
    builder.addCase(addBrand.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addBrand.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addBrand.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(updateBrand.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateBrand.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateBrand.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(deleteBrand.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteBrand.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------------------------product--------------------------------
    builder.addCase(getAllProducts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllProducts.fulfilled, (state, action) => {
      state.loading = false;
      state.productData = action.payload;
    });
    builder.addCase(addProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addProduct.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(updateProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateProduct.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(deleteProduct.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteProduct.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // --------------------------------------vendor-----------------------------------
    builder.addCase(getAllVendors.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllVendors.fulfilled, (state, action) => {
      state.loading = false;
      state.vendorData = action.payload;
    });
    builder.addCase(addVendor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addVendor.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addVendor.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(updateVendor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateVendor.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateVendor.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(deleteVendor.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteVendor.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    //QUTATION
    builder.addCase(getAllProductsWithoutPagination.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllProductsWithoutPagination.fulfilled,
      (state, action) => {
        state.loading = false;
        state.productData = action.payload;
      }
    );
    builder.addCase(getAllVendorsWithoutPagination.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllVendorsWithoutPagination.fulfilled,
      (state, action) => {
        state.loading = false;
        state.vendorData = action.payload;
      }
    );
    //..................GETING ALL REQUIREMENTS................
    builder.addCase(getQuotationRequirements.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getQuotationRequirements.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        resData: {
          ...state.resData,
          data: action?.payload?.data,
          meta: action?.payload?.meta,
        },
      };
    });
    builder.addCase(createRequirement.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createRequirement.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getQuotationsOfRequrements.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getQuotationsOfRequrements.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        quotationsData: action?.payload?.data,
      };
    });
    builder.addCase(updateQuotations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateQuotations.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(deleteQuotation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteQuotation.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(approveQuotation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(approveQuotation.fulfilled, (state, action) => {
      state.loading = false;
    });

    //GET PURCHASE ITEMS
    builder.addCase(getPurchasedItems.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPurchasedItems.fulfilled, (state, action) => {
      state.loading = false;
      state.purchasedDetails = action.payload;
    });
    // POST PURCHASE
    builder.addCase(createPurchase.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createPurchase.fulfilled, (state, action) => {
      state.loading = false;
    });
    // UPDATE PURCHASE
    builder.addCase(updatePurchase.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updatePurchase.fulfilled, (state, action) => {
      state.loading = false;
    });

    //GET SALE ITEMS
    builder.addCase(getSale.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSale.fulfilled, (state, action) => {
      state.loading = false;
      state.saleDetails = action.payload;
    });
    // POST Sale
    builder.addCase(createSale.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createSale.fulfilled, (state, action) => {
      state.loading = false;
    });
    // UPDATE Sale
    builder.addCase(updateSale.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateSale.fulfilled, (state, action) => {
      state.loading = false;
    });
    // DELETE SALE
    builder.addCase(deleteSale.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteSale.fulfilled, (state, action) => {
      state.loading = false;
    });
    // APPROVE OR REJECT SALE
    builder.addCase(approveOrRejectSaleRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(approveOrRejectSaleRequest.fulfilled, (state, action) => {
      state.loading = false;
    });
    // VERIFY AND SALE
    builder.addCase(verifySaleTheProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(verifySaleTheProduct.fulfilled, (state, action) => {
      state.loading = false;
    });
    //  HAND BACK THE PRODUCT
    builder.addCase(handBackTheProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(handBackTheProduct.fulfilled, (state, action) => {
      state.loading = false;
    });
    // GET CATEGORY TYPES
    builder.addCase(getCategoryTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCategoryTypes.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryTypes = action.payload.data;
    });
    // GET NO LIMIT CATEGORY TYPES
    builder.addCase(getCategoryTypesNoLimit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCategoryTypesNoLimit.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryTypesNoLimit = action.payload.data;
    });
    // UPDATE CATEGORY TYPES
    builder.addCase(updateCategoryTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCategoryTypes.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ADD CATEGORY TYPES
    builder.addCase(addCategoryTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCategoryTypes.fulfilled, (state, action) => {
      state.loading = false;
    });
    // DELETE CATEGORY TYPES
    builder.addCase(deleteCategoryTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCategoryTypes.fulfilled, (state, action) => {
      state.loading = false;
    });
    // GET SUBCATEGORIES
    builder.addCase(getSubcategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubcategories.fulfilled, (state, action) => {
      state.loading = false;
      state.subCategoryData = action.payload.data;
    });
    // ADD SUBCATEGORY
    builder.addCase(addSubCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addSubCategory.fulfilled, (state, action) => {
      state.loading = false;
    });
    // UPDATE SUBCATEGORY
    builder.addCase(updateSubcategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateSubcategory.fulfilled, (state, action) => {
      state.loading = false;
    });
    // DELETE SUBCATEGORY
    builder.addCase(deleteSubcategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteSubcategory.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getProductListForAddRequirement.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getProductListForAddRequirement.fulfilled,
      (state, action) => {
        state.loading = false;
        state.productDataForRequirement = action.payload;
      }
    );
    //PRODUCT SERIAL DATAS
    builder.addCase(availableProductsCodeAndTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      availableProductsCodeAndTypes.fulfilled,
      (state, action) => {
        state.loading = false;
        state.productSerialData = action.payload.data;
      }
    );
    //INVENTORY GET
    //INVENTORY GET
    builder.addCase(getInventoryData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInventoryData.fulfilled, (state, action) => {
      state.loading = false;
      state.inventoryData = action.payload;
    });
    //MARKING AS PRODUCT DAMAGED
    builder.addCase(markAsDamaged.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(markAsDamaged.fulfilled, (state, action) => {
      state.loading = false;
    });
    //REVERTING  AS PRODUCT GOOD
    builder.addCase(revertToGoodCondition.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(revertToGoodCondition.fulfilled, (state, action) => {
      state.loading = false;
    });
    //GETTING ALL SUBCATOGORIS
    builder.addCase(getAllSubCatWithNoLimit.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAllSubCatWithNoLimit.fulfilled, (state, action) => {
      state.allSubCatData = action.payload.data || [];
      state.loading = false;
    });
    //GETTING PURCHASED USER LIST EXCEPT ASSET
    builder.addCase(viewUsersList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(viewUsersList.fulfilled, (state, action) => {
      state.userPurchaseList = action.payload.data || [];
      state.loading = false;
    });
    // get dashboard data
    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.loading = false;
      state.dashboardData = action.payload.data;
    });
    // update deliverdate
    builder.addCase(updateDeliveryTime.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateDeliveryTime.fulfilled, (state, action) => {
      state.loading = false;
    });
    // APPROVE OR REJECT PROCUREMENT HEAD
    builder.addCase(approveOrRejectProcurementHead.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      approveOrRejectProcurementHead.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    );
    //...............................GET ALL DEPARTMENTS......................//
    builder.addCase(getAllDepartments.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAllDepartments.fulfilled, (state, action) => {
      return {
        ...state,
        departments: action.payload?.data,
        loading: false,
      };
    });
    //...............................GET ALL USERS UNDER DEPARTMENT......................//
    builder.addCase(getUsersUnderDepartment.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getUsersUnderDepartment.fulfilled, (state, action) => {
      return {
        ...state,
        usersUnderDepartment: action.payload?.data || [],
        loading: false,
      };
    });
    //...............................GET ALL PRODUCTS COUNT......................//
    builder.addCase(getAllProductsCount.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAllProductsCount.fulfilled, (state, action) => {
      return {
        ...state,
        allProductsCount: action.payload.data,
        loading: false,
      };
    });
    //...............................GET CHART DATA......................//
    builder.addCase(getChartdata.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getChartdata.fulfilled, (state, action) => {
      return {
        ...state,
        chartData: action.payload.data,
        loading: false,
      };
    });
    //...............................GET ALL DEPARTMENTS......................//
    builder.addCase(fetchAlldepartments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAlldepartments.fulfilled, (state, action) => {
      state.loading = false;
      state.allDepartments = action.payload.data;
    });
    //...............................FETCH USER UNDER DEPARTMENT......................//
    builder.addCase(fetchUserunderdepartment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchUserunderdepartment.fulfilled, (state, action) => {
      state.loading = false;
      state.usersunderdpt = action.payload.data;
    });
    //...............................CHANGE USER......................//
    builder.addCase(changeUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(changeUser.fulfilled, (state, action) => {
      state.loading = false;
    });
        //...............................CHANGE STATUS HOLD OR REJECT......................//
    builder.addCase(holdOrReject.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(holdOrReject.fulfilled, (state, action) => {
      state.loading = false;
    });
        // ---------------------------GENERAL FILE UPLOAD-----------------------------
        builder.addCase(commonFileUpload.pending, (state, action) => {
          return {
            ...state,
            // loading: true,
            fileUploadLoading:true
          };
        });
        builder.addCase(commonFileUpload.fulfilled, (state, action) => {
          const data = action.payload?.data;
          return {
            ...state,
            fileName: data,
            // loading: false,
            fileUploadLoading:false
          };
        });
  },
});

export const { clearQuotationsDataArray } = assetSlice.actions;

export default assetSlice.reducer;
